module.exports = __webpack_public_path__ + "static/cf-med-0ec85598c0cce4de35ad4e5101d34e02.eot";